import { changeTrackResolution, changeTrackResolutionActive, changeTrackResolutionAudienceMode, changeTrackResolutionPresentation, changeTrackResolutionSmallActive } from "../libs";
import { setActiveParticipant, setActiveTimerWidget, setAudienceParticipants, setCurrentActiveVideoTracks, setGalleryViewParticipants, setLastActiveWidget, setParticipantsJIDList, setParticipantsList, setPresentationParticipant, setScreenDimension, setTimerExtensionDetails, setTimerExtensionShow, setTrackStreamStatus } from "../reduxStore/confSlice";
import { store } from "../reduxStore/store";
import { isRlink } from "./constants";
import { AVATAR_COLORS, AVATAR_OPACITY, getWidgetCode, TILE_ASPECT_RATIO, viewType } from "./util";
import * as Sentry from "@sentry/react";

export function getAvatarColor(initials) {
  return '#EEEEEE';
  // if (isRlink) {
  //   return 'rgba(17, 17, 17, 1)';
  // } else {
  //   let colorIndex = 0;

  //   if (initials) {
  //     let nameHash = 0;

  //     for (const s of initials) {
  //       nameHash += s.codePointAt(0);
  //     }

  //     colorIndex = nameHash % AVATAR_COLORS.length;
  //   }

  //   return `rgba(${AVATAR_COLORS[colorIndex]}, ${AVATAR_OPACITY})`;
  // }

}

export function _getAvatarStyle(color) {
  return {
    backgroundColor: color || undefined,
    height: '100%',
    width: '100%',
  };
}

export const checkLinkSubstitution = (url) => {
  const state = store.getState();
  const { roomDetail } = state.conf;
  let link_substitution = roomDetail?.link_substitution ?? [];

  let found = link_substitution?.find((v) => url.includes(v.actual_text));

  if (found) {
    let isUrl = validURL(url);
    if (isUrl) {
      let isReplaceTextUrl = validURL(found.replace_text);

      if (isReplaceTextUrl) {
        url = found.replace_text;
        return url;
      } else {
        url = replaceLinks(url, found.actual_text, found.replace_text);
        return url;
      }
    } else {
      return url;
    }
  } else {
    return url;
  }
};

export function replaceLinks(inputText, replaceText, replaceWith) {
  var replacedText, replacePattern1, replacePattern2, replacePattern3;

  //URLs starting with http://, https://, or ftp://
  replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
  replacedText = inputText.replace(replacePattern1, function (url) {
    return url.replace(replaceText, replaceWith);
  });

  //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
  replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  replacedText = replacedText.replace(replacePattern2, function (url) {
    return url.replace(replaceText, replaceWith);
  });

  //Url without http https
  replacePattern3 = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
  replacedText = replacedText.replace(replacePattern3, function (url) {
    return url.replace(replaceText, replaceWith);
  });

  return replacedText;
}
function validURL(str) {
  var pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
    "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
    "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
    "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
    "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
    "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // fragment locator
  return !!pattern.test(str);
}
export const ShowActiveSpeakerOnFirstPage = () => {
  const state = store.getState();
  const { dispatch } = store;
  const { dominantSpeaker, participantsJID, localUser, maxVideos } = state.conf;
  if (dominantSpeaker !== null && dominantSpeaker !== localUser?.jid) {
    const galleryViewJid = Object.keys(participantsJID).slice(0, maxVideos - 1);
    const isDominatExist = galleryViewJid.includes(dominantSpeaker);
    if (!isDominatExist) {
      const UpdatedParticipantsJID = {};
      const tmpParticipantsJID = [...Object.keys(participantsJID)];
      const DominatIndex = tmpParticipantsJID.findIndex((item) => item === dominantSpeaker);
      const sortedList = getParticipiantsJidSortedData(Object.values(participantsJID).slice(0, maxVideos - 1));
      const leastUserSpeakIndex = tmpParticipantsJID.findIndex((item) => item === sortedList[sortedList.length - 1].jid);
      if (DominatIndex !== -1) {
        const tmpData = tmpParticipantsJID[leastUserSpeakIndex];
        tmpParticipantsJID[leastUserSpeakIndex] = tmpParticipantsJID[DominatIndex];
        tmpParticipantsJID[DominatIndex] = tmpData;
        tmpParticipantsJID.forEach((jidItem) => {
          UpdatedParticipantsJID[jidItem] = participantsJID[jidItem];
        });
        dispatch(setParticipantsJIDList(UpdatedParticipantsJID));
      }
    }
  }
};

export const getParticipiantsJidSortedData = (data) => {
  let list = [...data];
  let speakUsers = list.filter((z) => z.last_speak_time !== undefined);
  const unSpeakUser = list.filter((b) => b.last_speak_time === undefined);
  if (speakUsers.length > 0) {
    const sortedSpeakUsers = speakUsers.sort(function (x, y) {
      return y.last_speak_time - x.last_speak_time;
    });
    list = [...sortedSpeakUsers, ...unSpeakUser];
  }
  return list;
};

export const getPartcipiantsUserIds = () => {
  const state = store.getState();
  const { view, galleryViewParticipants, tracks } = state.conf;
  const usersId = [];
  if (view !== "gallery") {
    galleryViewParticipants.forEach((item) => {
      let trackArray = tracks.filter((t) => t.participantId === item.jid && t.type === "video" && t.mediaType === "camera" && t.muted === false);
      if (trackArray.length > 0) {
        let track = trackArray[0];
        usersId.push(track.jitsiTrack.getSourceName());
      }
    });
  }

  return usersId;
};

export const handleTrackStreamingStatusChanged = (jitsiTrack, streamingStatus) => {
  const { dispatch } = store;
  const state = store.getState();
  const { galleryViewParticipants, activeParticipant, roomDetail } = state.conf;
  let trackStreamStatus = jitsiTrack?.trackStreamStatus;

  let endpointId = jitsiTrack?.ownerEndpointId;
  let videoTypeCamera = jitsiTrack?.videoType === "camera";

  let galleryParticipantsJids = galleryViewParticipants.map((v) => v?.jid);
  console.log("galleryParticipantsJids", galleryParticipantsJids, roomDetail?.recorder_view, activeParticipant?.jid, endpointId);
  if (roomDetail?.recorder_view === viewType.gallery) {
    if (galleryParticipantsJids?.includes(endpointId) && videoTypeCamera) {
      let streamStatus = {
        [jitsiTrack.ownerEndpointId]: streamingStatus,
      };
      dispatch(setTrackStreamStatus(streamStatus));
    }
  } else if (roomDetail?.recorder_view === viewType.active) {
    if (activeParticipant?.jid === endpointId) {
      let streamStatus = {
        [jitsiTrack.ownerEndpointId]: streamingStatus,
      };
      dispatch(setTrackStreamStatus(streamStatus));
    }
  }
};
export const isTrackStreamingStatusActive = (videoTrack) => {
  const state = store.getState();
  const { trackStreamStatus } = state.conf;
  let currentStatus = trackStreamStatus[videoTrack?.ownerEndpointId];

  let isActive = currentStatus === "inactive" || currentStatus === "restoring" || currentStatus === "interrupted" ? false : true;
  console.log("isActive", isActive, currentStatus);
  return isActive;
};

export const getTrackVideoStatus = (videoTrack) => {
  const state = store.getState();
  const { trackStreamStatus } = state.conf;
  let currentStatus = trackStreamStatus[videoTrack?.ownerEndpointId];

  return currentStatus;
};

export const calculateGallerySize = (participants) => {
  return (dispatch, getState) => {
    const state = getState();
    const { screenDimension, windowDimension } = state.conf;

    let { clientWidth, clientHeight } = windowDimension;
    let { columns, minVisibleRows, maxColumns = 6, rows } = screenDimension;
    let height = 0,
      width = 0,
      viewWidth = 0,
      screenWidth = 0,
      screenHeight = 0;

    const columnsToMaintainASquare = Math.ceil(Math.sqrt(participants));
    columns = Math.min(columnsToMaintainASquare, maxColumns);
    rows = Math.ceil(participants / columns);
    minVisibleRows = Math.min(maxColumns, rows);

    // navBarHeight = document.getElementById("conference-nav-bar")?.clientHeight;
    // btmBarHeight = document.getElementById('free-forever-btmBr')?.clientHeight

    // const sideMargins = 30 * 2;
    //const sideMargins = 0

    viewWidth = clientWidth;
    screenWidth = clientWidth;
    screenHeight = clientHeight;

    // const initialWidth = viewWidth / columns;
    // Account for video block margins (0.1vh per block)
    const marginPerBlockVh = 0.1;
    const marginPerBlockPx = (marginPerBlockVh / 100) * clientHeight;
    const totalHorizontalMargin = marginPerBlockPx * 2 * columns; // 2 sides per block
    const totalVerticalMargin = marginPerBlockPx * 2 * minVisibleRows; // 2 sides per block

    const adjustedViewWidth = viewWidth - totalHorizontalMargin;
    const adjustedScreenHeight = screenHeight - totalVerticalMargin;

    const initialWidth = adjustedViewWidth / columns;
    const aspectRatioHeight = initialWidth / TILE_ASPECT_RATIO;

    // const initialHeight = screenHeight / minVisibleRows;

    const initialHeight = adjustedScreenHeight / minVisibleRows;

    height = Math.floor(Math.min(aspectRatioHeight, initialHeight));
    width = Math.floor(TILE_ASPECT_RATIO * height);

    // Calculate single box dimensions for active and presentation views
    // Use same calculation logic as gallery view (height/width) for consistency
    const singleUserInitialWidth = adjustedViewWidth / 1; // Single column
    const singleUserAspectRatioHeight =
      singleUserInitialWidth / TILE_ASPECT_RATIO;

    const singleUserInitialHeight = adjustedScreenHeight / 1; // Single row

    const singleUserViewHeight = Math.floor(
      Math.min(singleUserAspectRatioHeight, singleUserInitialHeight),
    );
    const singleUserViewWidth = Math.floor(
      TILE_ASPECT_RATIO * singleUserViewHeight,
    );
    console.log("setScreenDimension", screenDimension, viewWidth);
    dispatch(
      setScreenDimension({
        ...screenDimension,
        ...{
          columns,
          rows,
          minVisibleRows,
          height,
          width,
          viewWidth,
          screenHeight,
          screenWidth,
          singleUserViewHeight,
          singleUserViewWidth,
        },
      })
    );
  };
};

export const getTrackKey = (id, type) => {
  return `${id}_${type}`;
};

export const getMirrorClass = (jid) => {
  const state = store.getState();
  const { participantsJID } = state.conf;
  const participant = participantsJID?.[jid];
  return participant?.mirror_view ? 'flipVideoX' : '';
};

export const isUpdateTrack = (
  trackType,
  trackKey,
  track,
  participantsTracks,
) => {
  let check = false;
  if (trackType === 'video') {
    if (participantsTracks[trackKey]) {
      const sourceName = participantsTracks[trackKey]?.jitsiTrack?._sourceName;
      if (sourceName === track?._sourceName) {
        check = true;
      } else {
        check = false;
      }
    } else {
      check = true;
    }
  } else {
    check = true;
  }

  return check;
};

export const setGalleryParticipiants = (tmpParticipantsJID) => {
  const state = store.getState();
  const { dispatch } = store;
  const { participantsJID, roomDetail, numPages, maxVideos, localDesktopVideoTrack, localVideoTrack, localUser, currrentPage, participantsTracks, unmutedParticipantIds, audioMode } = state.conf;

  const { hide_muted_attendees } = roomDetail;

  const participantsJIDData = tmpParticipantsJID ? tmpParticipantsJID : participantsJID;

  let galleryParticipantData = [];
  let unmutedUsersForHideMuted = [];

  const finalJid = hide_muted_attendees ? unmutedParticipantIds : Object.keys(participantsJIDData);

  let requestIds = [];

  let currentActiveTrack = {};

  finalJid.forEach((id) => {
    const videoTrackkey = getTrackKey(id, "video");
    const desktopTrackkey = getTrackKey(id, "desktop");
    const userVideoTrack = participantsTracks[videoTrackkey];
    const desktopTrack = participantsTracks[desktopTrackkey];

    if (userVideoTrack?.muted === false) {
      const participant = {
        track: userVideoTrack.jitsiTrack,
        type: "camera",
        name: participantsJIDData[id].name,
        profile_image: participantsJIDData[id]?.profile_image,
        isAttendeeRecorder: participantsJIDData[id]?.attendee_recording,
        jid: id,
        local: false,
      };
      galleryParticipantData.push(participant);
      currentActiveTrack[videoTrackkey] = userVideoTrack;
      requestIds.push(userVideoTrack.jitsiTrack.getSourceName());
    } else {
      const participant = {
        track: null,
        type: "camera",
        name: participantsJIDData[id].name,
        profile_image: participantsJIDData[id]?.profile_image,
        isAttendeeRecorder: participantsJIDData[id]?.attendee_recording,
        jid: id,
        local: false,
      };
      galleryParticipantData.push(participant);
    }

    if (desktopTrack?.muted === false && participantsJIDData[id]?.screenShare && !participantsJIDData[id]?.blocked) {
      const participant = {
        track: desktopTrack.jitsiTrack,
        type: "desktop",
        name: participantsJIDData[id].name + "&#39;s Presentation",
        profile_image: participantsJIDData[id]?.profile_image,
        isAttendeeRecorder: participantsJIDData[id]?.attendee_recording,
        jid: id,
        local: false,
      };
      galleryParticipantData.push(participant);
      requestIds.push(desktopTrack.jitsiTrack.getSourceName());
      currentActiveTrack[desktopTrackkey] = desktopTrack;
    }
  });

  // const finalRequestIds = requestIds.slice(startCount, endCount);
  const specificNumberGalleryParticipantData = galleryParticipantData.slice(0, maxVideos);

  const finalGalleryParticipantData = [...specificNumberGalleryParticipantData];

  // const finalCurrentActiveTrack = objSlice(
  //   currentActiveTrack,
  //   startCount,
  //   endCount,
  // );
  let finalCurrentActiveTrack = {};
  let finalRequestIds = [];
  for (let user of specificNumberGalleryParticipantData) {
    for (let key in currentActiveTrack) {
      if (currentActiveTrack[key].participantId === user.jid) {
        finalCurrentActiveTrack[key] = currentActiveTrack[key];
        finalRequestIds.push(currentActiveTrack[key]?.jitsiTrack?.getSourceName());
      }
    }
  }
  console.log('set Gallery changeTrackResolution');
  changeTrackResolution(finalRequestIds);
  dispatch(setCurrentActiveVideoTracks(finalCurrentActiveTrack));
  dispatch(setGalleryViewParticipants(finalGalleryParticipantData));
  dispatch(calculateGallerySize(finalGalleryParticipantData.length));
};

export const setActiveExcludingYourselfParticipant = (requestVideo = true) => {
  const { dispatch } = store;
  const state = store.getState();
  const {
    roomDetail,
    localUser,
    participantsJID,
    dominantSpeaker,
    recentActiveSpeaker,
    recentUnmutedUsers,
    participantsTracks,
  } = state.conf;
  const hideMutedAttendees = roomDetail?.hide_muted_attendees;
  let track = null;
  let tmpParticipant = {};
  let activeSpeakerParticipant = {};
  let _currentVideoTracks = [];

  const usersId = [];
  const tmpRecentActiveSpeaker = recentActiveSpeaker.filter(
    item => item !== localUser?.jid,
  );
  const tmpRecentUnmutedUsers = recentUnmutedUsers.filter(
    item => item.jid !== localUser?.jid,
  );

  if (hideMutedAttendees) {
    if (
      participantsJID[dominantSpeaker] &&
      participantsJID[dominantSpeaker].audio === true
    ) {
      let id = dominantSpeaker;
      tmpParticipant = participantsJID[id];
      const videoTrackKey = getTrackKey(id, 'video');
      const userVideoTrack = participantsTracks[videoTrackKey];

      if (userVideoTrack?.muted === false) {
        track = userVideoTrack;
        usersId.unshift(userVideoTrack.jitsiTrack.getSourceName());
      } else {
        track = null;
      }
    } else if (
      participantsJID[tmpRecentActiveSpeaker[0]] &&
      participantsJID[tmpRecentActiveSpeaker[0]].audio === true
    ) {
      let id = tmpRecentActiveSpeaker[0];
      tmpParticipant = participantsJID[id];
      const videoTrackKey = getTrackKey(id, 'video');
      const userVideoTrack = participantsTracks[videoTrackKey];

      if (userVideoTrack?.muted === false) {
        track = userVideoTrack;
        usersId.unshift(userVideoTrack.jitsiTrack.getSourceName());
      } else {
        track = null;
      }
    } else if (tmpRecentUnmutedUsers[0]) {
      let id = tmpRecentUnmutedUsers[0].jid;
      tmpParticipant = participantsJID[id];
      const videoTrackKey = getTrackKey(id, 'video');
      const userVideoTrack = participantsTracks[videoTrackKey];

      if (userVideoTrack?.muted === false) {
        track = userVideoTrack;
        usersId.unshift(userVideoTrack.jitsiTrack.getSourceName());
      } else {
        track = null;
      }
    } else {
      track = null;
    }
  } else {
    if (participantsJID[dominantSpeaker]) {
      let id = dominantSpeaker;
      tmpParticipant = participantsJID[id];
      const videoTrackKey = getTrackKey(id, 'video');
      const userVideoTrack = participantsTracks[videoTrackKey];

      if (userVideoTrack?.muted === false) {
        track = userVideoTrack;
        usersId.unshift(userVideoTrack.jitsiTrack.getSourceName());
      } else {
        track = null;
      }
    } else if (participantsJID[tmpRecentActiveSpeaker[0]]) {
      let id = tmpRecentActiveSpeaker[0];
      tmpParticipant = participantsJID[id];
      const videoTrackKey = getTrackKey(id, 'video');
      const userVideoTrack = participantsTracks[videoTrackKey];

      if (userVideoTrack?.muted === false) {
        track = userVideoTrack;
        usersId.unshift(userVideoTrack.jitsiTrack.getSourceName());
      } else {
        track = null;
      }
    }
  }

  if (requestVideo) {
    changeTrackResolutionActive(usersId);
  }

  if (track) {
    _currentVideoTracks.push(track);
    dispatch(setCurrentActiveVideoTracks(_currentVideoTracks));
  }

  activeSpeakerParticipant = {
    track: track,
    name: tmpParticipant?.name,
    profile_image: tmpParticipant?.profile_image,
    jid: tmpParticipant?.jid,
    audio: tmpParticipant?.audio,
    local: tmpParticipant?.jid === localUser?.jid,
  };

  console.log('activeSpeakerParticipant', activeSpeakerParticipant);
  dispatch(setActiveParticipant(activeSpeakerParticipant));
  return activeSpeakerParticipant;
};

export const setPresentationViewParticipant = showActiveWindow => {
  const { dispatch } = store;
  const state = store.getState();
  const {
    participantsJID,
    screenSharedJid,
    mediaShareparticipantsJID,
    participantsTracks,
  } = state.conf;
  let track = null;
  let _currentVideoTracks = [];
  let user_id = '';

  const participant = participantsJID[screenSharedJid];
  if (participant) {
    const desktopTrackKey = getTrackKey(screenSharedJid, 'desktop');
    const userDesktopTrack = participantsTracks[desktopTrackKey];
    if (userDesktopTrack?.muted === false) {
      track = userDesktopTrack;
    }
    user_id = screenSharedJid;
  } else if (
    mediaShareparticipantsJID &&
    mediaShareparticipantsJID === screenSharedJid
  ) {
    const videoTrackKey = getTrackKey(screenSharedJid, 'video');
    const userVideoTrack = participantsTracks[videoTrackKey];

    if (userVideoTrack?.muted === false) {
      track = userVideoTrack;
    }
    user_id = screenSharedJid;
  }

  if (track) {
    if (!showActiveWindow) {
      changeTrackResolutionPresentation([track.jitsiTrack.getSourceName()]);
    }
    _currentVideoTracks.push(track);
    dispatch(setCurrentActiveVideoTracks(_currentVideoTracks));
  }

  const presentationParticipant = {
    track: track,
    name: participant?.name,
    jid: user_id,
    local: false,
  };

  dispatch(setPresentationParticipant(presentationParticipant));
};
export const setActiveSmallWindowParticipant = () => {
  const { dispatch } = store;
  const state = store.getState();
  const {
    screenSharedJid,
    roomDetail,
    localUser,
    participantsJID,
    dominantSpeaker,
    recentActiveSpeaker,
    recentUnmutedUsers,
    participantsTracks,
    currentActiveVideoTracks,
  } = state.conf;
  const hideMutedAttendees = roomDetail?.hide_muted_attendees;
  let track = null;
  let tmpParticipant = {};
  let activeSpeakerParticipant = {};
  let _currentVideoTracks = { ...currentActiveVideoTracks };


  const usersId = [];
  const tmpRecentActiveSpeaker = recentActiveSpeaker.filter(
    item => item !== localUser?.jid,
  );
  const tmpRecentUnmutedUsers = recentUnmutedUsers.filter(
    item => item.jid !== localUser?.jid,
  );

  if (hideMutedAttendees) {
    if (
      participantsJID[dominantSpeaker] &&
      participantsJID[dominantSpeaker].audio === true
    ) {
      let id = dominantSpeaker;
      tmpParticipant = participantsJID[id];
      const videoTrackKey = getTrackKey(id, 'video');
      const userVideoTrack = participantsTracks[videoTrackKey];

      if (userVideoTrack?.muted === false) {
        track = userVideoTrack;
        usersId.unshift(userVideoTrack.jitsiTrack.getSourceName());
      } else {
        track = null;
      }

      if (screenSharedJid) {
        const desktopTrackKey = getTrackKey(screenSharedJid, 'desktop');
        const userDesktopTrack = participantsTracks[desktopTrackKey];

        if (userDesktopTrack) {
          usersId.unshift(userDesktopTrack.jitsiTrack.getSourceName());
        }
      }
    } else if (
      participantsJID[tmpRecentActiveSpeaker[0]] &&
      participantsJID[tmpRecentActiveSpeaker[0]].audio === true
    ) {
      let id = tmpRecentActiveSpeaker[0];
      tmpParticipant = participantsJID[id];
      const videoTrackKey = getTrackKey(id, 'video');
      const userVideoTrack = participantsTracks[videoTrackKey];

      if (userVideoTrack?.muted === false) {
        track = userVideoTrack;
        usersId.unshift(userVideoTrack.jitsiTrack.getSourceName());
      } else {
        track = null;
      }

      if (screenSharedJid) {
        const desktopTrackKey = getTrackKey(screenSharedJid, 'desktop');
        const userDesktopTrack = participantsTracks[desktopTrackKey];

        if (userDesktopTrack) {
          usersId.unshift(userDesktopTrack.jitsiTrack.getSourceName());
        }
      }
    } else if (tmpRecentUnmutedUsers[0]) {
      let id = tmpRecentUnmutedUsers[0].jid;
      tmpParticipant = participantsJID[id];
      const videoTrackKey = getTrackKey(id, 'video');
      const userVideoTrack = participantsTracks[videoTrackKey];

      if (userVideoTrack?.muted === false) {
        track = userVideoTrack;
        usersId.unshift(userVideoTrack.jitsiTrack.getSourceName());
      } else {
        track = null;
      }
      if (screenSharedJid) {
        const desktopTrackKey = getTrackKey(screenSharedJid, 'desktop');
        const userDesktopTrack = participantsTracks[desktopTrackKey];

        if (userDesktopTrack) {
          usersId.unshift(userDesktopTrack.jitsiTrack.getSourceName());
        }
      }
    } else {
      track = null;
      if (screenSharedJid) {
        const desktopTrackKey = getTrackKey(screenSharedJid, 'desktop');
        const userDesktopTrack = participantsTracks[desktopTrackKey];

        if (userDesktopTrack) {
          usersId.unshift(userDesktopTrack.jitsiTrack.getSourceName());
        }
      }
    }
  } else {
    if (participantsJID[dominantSpeaker]) {
      let id = dominantSpeaker;
      tmpParticipant = participantsJID[id];
      const videoTrackKey = getTrackKey(id, 'video');
      const userVideoTrack = participantsTracks[videoTrackKey];

      if (userVideoTrack?.muted === false) {
        track = userVideoTrack;
        usersId.unshift(userVideoTrack?.jitsiTrack?.getSourceName());
      } else {
        track = null;
      }

      if (screenSharedJid) {
        const desktopTrackKey = getTrackKey(screenSharedJid, 'desktop');
        const userDesktopTrack = participantsTracks[desktopTrackKey];

        if (userDesktopTrack) {
          usersId.unshift(userDesktopTrack.jitsiTrack.getSourceName());
        }
      }
    } else if (participantsJID[tmpRecentActiveSpeaker[0]]) {
      let id = tmpRecentActiveSpeaker[0];
      tmpParticipant = participantsJID[id];
      const videoTrackKey = getTrackKey(id, 'video');
      const userVideoTrack = participantsTracks[videoTrackKey];

      if (userVideoTrack?.muted === false) {
        track = userVideoTrack;
        usersId.unshift(userVideoTrack.jitsiTrack.getSourceName());
      } else {
        track = null;
      }

      if (screenSharedJid) {
        const desktopTrackKey = getTrackKey(screenSharedJid, 'desktop');
        const userDesktopTrack = participantsTracks[desktopTrackKey];

        if (userDesktopTrack) {
          usersId.unshift(userDesktopTrack.jitsiTrack.getSourceName());
        }
      }
    }
  }

  changeTrackResolutionSmallActive(usersId);

  if (track) {
    // _currentVideoTracks.push(track);
    _currentVideoTracks[track.participantId] = track;
    dispatch(setCurrentActiveVideoTracks(_currentVideoTracks));
  }

  activeSpeakerParticipant = {
    track: track,
    name: tmpParticipant?.name,
    profile_image: tmpParticipant?.profile_image,
    jid: tmpParticipant?.jid,
    audio: tmpParticipant?.audio,
    local: tmpParticipant?.jid === localUser?.jid,
  };
  dispatch(setActiveParticipant(activeSpeakerParticipant));
};
// export const setAudienceModeParticipiants = async () => {
//   const state = store.getState();
//   const { dispatch } = store;
//   const {
//     participantsJID,
//     roomDetail,
//     maxVideos,
//     currrentAudiencePage,
//     participantsTracks,
//     unmutedParticipantIds,
//     audioMode,
//   } = state.conf;

//   const { hide_muted_attendees } = roomDetail;
//   const participantsJIDData = {...participantsJID};
//   let currentActiveTrack = {};
//   let requestIds = [];

//   const otherParticipants = [];

//   // First pass: Process dominant speaker
//   const activeSpeakerResult = await setActiveExcludingYourselfParticipant(false);

//   console.log('setActiveExcludingYourselfParticipant', activeSpeakerResult);

//   let dominantSpeakerData = {
//     track: null,
//     type: 'camera',
//     name: activeSpeakerResult?.name,
//     profile_image: activeSpeakerResult?.profile_image,
//     jid: activeSpeakerResult?.jid,
//     local: false,
//     isDominantSpeaker: true,
//   };

//   // Check if dominant speaker should be included based on hide_muted_attendees setting
//   const shouldIncludeDominantSpeaker = hide_muted_attendees ? (unmutedParticipantIds.includes(activeSpeakerResult?.jid)) : true;

//   // Add dominant speaker data if available and should be included
//   if (activeSpeakerResult?.track?.jitsiTrack?.muted === false && shouldIncludeDominantSpeaker) {
//     dominantSpeakerData = {
//       ...dominantSpeakerData,
//       track: activeSpeakerResult?.track?.jitsiTrack,
//     };
//     const videoTrackKey = getTrackKey(activeSpeakerResult?.jid, 'video');
//     currentActiveTrack[videoTrackKey] = activeSpeakerResult?.track;
//     requestIds.push(activeSpeakerResult?.track?.jitsiTrack?.getSourceName());
//   }  else if (!shouldIncludeDominantSpeaker) {
//     // If dominant speaker is muted and should be hidden, set to null
//     dominantSpeakerData = null;
//   }

//   // Calculate how many visible participants we need (active speaker + maxVideos)
//   const participantsPerPage = maxVideos;

//   // Get all available participants (excluding dominant speaker, including localUser)
//   const allParticipantIds = hide_muted_attendees ? unmutedParticipantIds : Object.keys(participantsJIDData);
//   let availableParticipants = allParticipantIds.filter(id => id !== activeSpeakerResult?.jid);

//   console.log('availableParticipants', availableParticipants,allParticipantIds);

//   // Calculate pagination
//   const totalParticipants = availableParticipants.length;
//   const totalPages = Math.max(1, Math.ceil(totalParticipants / participantsPerPage));
//   const currentPage = 1;

//   console.log('totalPages', totalPages,maxVideos,currentPage);

//   // Get only the visible participants for current page (max 9 excluding active speaker)
//   const startIdx = (currentPage - 1) * participantsPerPage;
//   const endIdx = startIdx + participantsPerPage;
//   const visibleParticipantIds = availableParticipants.slice(startIdx, endIdx);

//   // Second pass: Process only visible participants
//   visibleParticipantIds.forEach(participantId => {
//     // Handle remote participants
//     const videoTrackKey = getTrackKey(participantId, 'video');
//     const videoTrack = participantsTracks[videoTrackKey];

//     // Add camera track if available
//     if (videoTrack?.muted === false) {
//       otherParticipants.push({
//         track: videoTrack?.jitsiTrack,
//         type: 'camera',
//         name: participantsJIDData[participantId]?.name,
//         profile_image: participantsJIDData[participantId]?.profile_image,
//         jid: participantId,
//         local: false,
//         isDominantSpeaker: false,
//       });
//       currentActiveTrack[videoTrackKey] = videoTrack;
//       requestIds.push(videoTrack?.jitsiTrack?.getSourceName());
//     } else {
//       // Add participant with muted video or without video track
//       otherParticipants.push({
//         track: videoTrack?.jitsiTrack || null,
//         type: 'camera',
//         name: participantsJIDData[participantId]?.name,
//         profile_image: participantsJIDData[participantId]?.profile_image,
//         jid: participantId,
//         local: false,
//         isDominantSpeaker: false,
//       });
//       if (videoTrack) {
//         currentActiveTrack[videoTrackKey] = videoTrack;
//       }
//     }

//   });

//   // Combine dominant speaker with other participants
//   const finalParticipants = [];
//   if (dominantSpeakerData && dominantSpeakerData?.jid) {
//     finalParticipants.push(dominantSpeakerData);
//   }
//   finalParticipants.push(...otherParticipants);

//   // request videos for audience mode
//   if (!audioMode) {
//     changeTrackResolutionAudienceMode(requestIds);
//   }

//   dispatch(setCurrentActiveVideoTracks(currentActiveTrack));
//   dispatch(setAudienceParticipants(finalParticipants));
// };

export const setAudienceModeParticipiants = async () => {
  const state = store.getState();
  const { dispatch } = store;
  const {
    participantsJID,
    roomDetail,
    maxVideos,
    currrentAudiencePage,
    participantsTracks,
    unmutedParticipantIds,
    audioMode,
    audienceParticipants,
    recentActiveSpeaker
  } = state.conf;

  console.log("participantsJID", participantsJID);

  const { hide_muted_attendees } = roomDetail;
  const participantsJIDData = { ...participantsJID };
  let currentActiveTrack = {};
  let requestIds = [];

  const otherParticipants = [];
  const recentSpeakersData = [];

  const maxRecentFromHistory = 3; // Use 3 from recentActiveSpeaker
  const maxTotalSpeakers = 4; // Total of 4 (3 from recent + 1 from active)

  // Get current active speaker from setActiveSpeakerParticipant
  const activeSpeakerResult = await setActiveExcludingYourselfParticipant(false);
  const activeSpeakerJid = activeSpeakerResult?.jid;

  console.log("recentActiveSpeaker", recentActiveSpeaker, activeSpeakerJid);

  // Preserve existing recent speakers from audienceParticipants (maintain positions)
  if (Array.isArray(audienceParticipants)) {
    audienceParticipants.forEach((participant) => {
      if (participant.isRecentSpeaker && recentSpeakersData.length < maxTotalSpeakers) {
        const isCurrentlyUnmuted = participantsJIDData[participant.jid]?.audio === true;

        // Don't add to recentSpeakersData if user audio is false
        if (isCurrentlyUnmuted) {
          let updatedParticipant = { ...participant };
          const videoTrackKey = getTrackKey(participant.jid, "video");
          const userVideoTrack = participantsTracks[videoTrackKey];
          if (userVideoTrack?.jitsiTrack?.muted === false) {
            updatedParticipant.track = userVideoTrack.jitsiTrack;
            currentActiveTrack[videoTrackKey] = userVideoTrack;
            requestIds.push(userVideoTrack.jitsiTrack.getSourceName());
          }
          recentSpeakersData.push(updatedParticipant);
        }
      }
    });
  }

  // If no recent speakers from audienceParticipants, use recentActiveSpeaker state
  if (recentSpeakersData.length === 0 && Array.isArray(recentActiveSpeaker) && recentActiveSpeaker.length > 0) {
    const recentSpeakersToUse = recentActiveSpeaker.slice(0, maxRecentFromHistory);

    recentSpeakersToUse.forEach((speakerJid) => {
      if (recentSpeakersData.length < maxRecentFromHistory) {
        const participantData = participantsJIDData[speakerJid];

        if (participantData) {
          const isCurrentlyUnmuted = participantData?.audio === true;

          // Don't add to recentSpeakersData if user audio is false
          if (isCurrentlyUnmuted) {
            let speakerData = {
              track: null,
              type: "camera",
              name: participantData?.name,
              profile_image: participantData?.profile_image,
              jid: speakerJid,
              local: false,
              isDominantSpeaker: false,
              isRecentSpeaker: true,
              isAttendeeRecorder: participantsJIDData[speakerJid]?.attendee_recording,
            };

            // Update track reference

            const videoTrackKey = getTrackKey(speakerJid, "video");
            const userVideoTrack = participantsTracks[videoTrackKey];
            if (userVideoTrack?.jitsiTrack?.muted === false) {
              speakerData.track = userVideoTrack.jitsiTrack;
              currentActiveTrack[videoTrackKey] = userVideoTrack;
              requestIds.push(userVideoTrack.jitsiTrack.getSourceName());
            }
            recentSpeakersData.push(speakerData);
          }
        }
      }
    });
  }

  // Add or replace active speaker if not already in the list
  if (activeSpeakerJid) {
    const alreadyInList = recentSpeakersData.find((s) => s.jid === activeSpeakerJid);

    if (!alreadyInList) {
      const participantData = participantsJIDData[activeSpeakerJid];

      if (participantData) {
        const isActiveSpeakerUnmuted = participantData?.audio === true;

        // Don't replace if active speaker audio is false
        if (isActiveSpeakerUnmuted) {
          let activeSpeakerData = {
            track: null,
            type: "camera",
            name: participantData?.name,
            profile_image: participantData?.profile_image,
            jid: activeSpeakerJid,
            local: false,
            isDominantSpeaker: true,
            isRecentSpeaker: true,
            isAttendeeRecorder: participantsJIDData[activeSpeakerJid]?.attendee_recording,
          };

          const videoTrackKey = getTrackKey(activeSpeakerJid, "video");
          const userVideoTrack = participantsTracks[videoTrackKey];
          if (userVideoTrack?.jitsiTrack?.muted === false) {
            activeSpeakerData.track = userVideoTrack.jitsiTrack;
            currentActiveTrack[videoTrackKey] = userVideoTrack;
            requestIds.push(userVideoTrack.jitsiTrack.getSourceName());
          }

          // Only replace with least recent speaker if already 4 speakers are there
          if (recentSpeakersData.length >= maxTotalSpeakers) {
            // Find the least recent speaker to replace
            let replaceIndex = 0; // Default fallback
            let oldestPosition = -1;

            // Strategy 1: Find speaker with highest index in recentActiveSpeaker (least recent)
            for (let i = 0; i < recentSpeakersData.length; i++) {
              const speakerJid = recentSpeakersData[i].jid;
              const positionInRecentList = recentActiveSpeaker.indexOf(speakerJid);

              // Higher index = older/less recent speaker
              if (positionInRecentList !== -1 && positionInRecentList > oldestPosition) {
                oldestPosition = positionInRecentList;
                replaceIndex = i;
              }
            }

            // Strategy 2: If no speakers found in recentActiveSpeaker, replace non-dominant speakers first
            if (oldestPosition === -1) {
              for (let i = 0; i < recentSpeakersData.length; i++) {
                if (!recentSpeakersData[i].isDominantSpeaker) {
                  replaceIndex = i;
                  break;
                }
              }
            }

            console.log(`Replacing speaker at index ${replaceIndex} (position ${oldestPosition} in recentActiveSpeaker)`);
            recentSpeakersData[replaceIndex] = activeSpeakerData;
          } else {
            // Add if there's space
            recentSpeakersData.push(activeSpeakerData);
          }
        }
      }
    }
  }

  // Get JIDs of recent speakers to exclude them from regular participants
  const recentSpeakerJids = recentSpeakersData.map((s) => s.jid);

  // Get all available participants (excluding recent speakers)
  const allParticipantIds = hide_muted_attendees
    ? unmutedParticipantIds
    : Object.keys(participantsJIDData);
  let availableParticipants = allParticipantIds.filter((id) => !recentSpeakerJids.includes(id));




  // Pagination
  const participantsPerPage = maxVideos;
  const totalParticipants = availableParticipants.length;
  const totalPages = Math.max(1, Math.ceil(totalParticipants / participantsPerPage));
  const currentPage = 1;

  const startIdx = (currentPage - 1) * participantsPerPage;
  const endIdx = startIdx + participantsPerPage;
  const visibleParticipantIds = availableParticipants.slice(startIdx, endIdx);

  console.log("availableParticipants1", availableParticipants, visibleParticipantIds, participantsPerPage, totalParticipants);

  // Build otherParticipants
  visibleParticipantIds.forEach((participantId) => {
    const videoTrackKey = getTrackKey(participantId, "video");
    const videoTrack = participantsTracks[videoTrackKey];

    otherParticipants.push({
      track: videoTrack?.muted === false ? videoTrack?.jitsiTrack : videoTrack?.jitsiTrack || null,
      type: "camera",
      name: participantsJIDData[participantId]?.name,
      profile_image: participantsJIDData[participantId]?.profile_image,
      jid: participantId,
      local: false,
      isDominantSpeaker: false,
      isRecentSpeaker: false,
      isAttendeeRecorder: participantsJIDData[participantId]?.attendee_recording,
    });

    if (videoTrack) {
      currentActiveTrack[videoTrackKey] = videoTrack;
      if (videoTrack?.muted === false) {
        requestIds.push(videoTrack?.jitsiTrack?.getSourceName());
      }
    }
  });

  // Combine final participants (recent speakers first)
  const finalParticipants = [...recentSpeakersData, ...otherParticipants];

  if (!audioMode) {
    changeTrackResolutionAudienceMode(requestIds, recentSpeakersData.length);
  }

  console.log("finalParticipants", finalParticipants, requestIds);

  dispatch(setCurrentActiveVideoTracks(currentActiveTrack));
  dispatch(setAudienceParticipants(finalParticipants));
};

export const setGalleryTracks = (participantsTracks, _isUpdateGallery, keepAliveRequest = false) => {
  const { dispatch } = store;
  const state = store.getState();
  const { galleryViewParticipants, audioMode } = state.conf;
  let participantId = [];

  let _participants = galleryViewParticipants.map(p => {
    let participant = { ...p };
    if (!participant.local) {
      if (participant.type === 'camera') {
        let trackKey = getTrackKey(participant.jid, 'video');
        const remoteVideoTrack = participantsTracks[trackKey];

        if (remoteVideoTrack?.muted === false) {
          participantId.push(remoteVideoTrack.jitsiTrack.getSourceName());
          participant.track = remoteVideoTrack.jitsiTrack;
        } else {
          participant.track = null;
        }
      }
      if (participant.type === 'desktop') {
        let trackKey = getTrackKey(participant.jid, 'desktop');
        const remoteDesktopTrack = participantsTracks[trackKey];
        if (remoteDesktopTrack?.muted === false) {
          participantId.push(remoteDesktopTrack.jitsiTrack.getSourceName());
          participant.track = remoteDesktopTrack.jitsiTrack;
        } else {
          participant.track = null;
        }
      }
    }

    return participant;
  });
  if (!audioMode) {
    changeTrackResolution(participantId, false, keepAliveRequest);
  }

  if (_isUpdateGallery) {
    dispatch(setGalleryViewParticipants(_participants));
  }
};

export const setPresentationTracks = (_isUpdatePresentation, showActiveWindow, keepAliveRequest = false) => {
  const { dispatch } = store;
  const state = store.getState();
  const {
    participantsJID,
    presentationParticipant,
    mediaShareparticipantsJID,
    screenSharedJid,
    participantsTracks,
  } = state.conf;
  const _presentationParticipant = { ...presentationParticipant };

  let track = null;
  let usersId = [];
  const participant = participantsJID[screenSharedJid];
  if (participant) {
    let trackKey = getTrackKey(screenSharedJid, 'desktop');
    const remoteDesktopTrack = participantsTracks[trackKey];
    if (remoteDesktopTrack?.muted === false) {
      usersId.push(remoteDesktopTrack?.jitsiTrack?.getSourceName());
      track = remoteDesktopTrack;
    }
  } else if (
    mediaShareparticipantsJID &&
    mediaShareparticipantsJID === screenSharedJid
  ) {
    let trackKey = getTrackKey(screenSharedJid, 'video');
    const remoteDesktopTrack = participantsTracks[trackKey];

    if (remoteDesktopTrack?.muted === false) {
      usersId.push(remoteDesktopTrack.jitsiTrack.getSourceName());
      track = remoteDesktopTrack;
    }
  }

  if (track) {
    if (_presentationParticipant && _presentationParticipant?.track === null) {
      if (!showActiveWindow) {
        changeTrackResolutionPresentation(usersId, keepAliveRequest);
      }
      _presentationParticipant.track = track;
      if (_isUpdatePresentation) {
        dispatch(setPresentationParticipant(_presentationParticipant));
      }
    }
  }
};
export const setActiveTracks = _isUpdateActiveParticipant => {
  const { dispatch } = store;
  const state = store.getState();
  const { activeParticipant, participantsTracks } = state.conf;
  const activeSpeakerParticipant = { ...activeParticipant };

  if (activeSpeakerParticipant && activeSpeakerParticipant?.track === null) {
    let trackKey = getTrackKey(activeParticipant.jid, 'video');
    const remoteVideoTrack = participantsTracks[trackKey];

    if (remoteVideoTrack?.muted === false) {
      activeSpeakerParticipant.track = remoteVideoTrack;
      dispatch(setActiveParticipant(activeSpeakerParticipant));
    }
  }
};

export const setAudienceTracks = () => {
  const { dispatch } = store;
  const state = store.getState();
  const { audienceParticipants, audioMode, participantsTracks, localUser, localVideoTrack } = state.conf;
  let requestIds = [];
  const recentSpeakersCount = audienceParticipants.filter(p => p.isRecentSpeaker).length;

  let _participants = audienceParticipants.map(p => {
    let participant = { ...p };
    if (participant.type === 'camera') {
      let trackKey = getTrackKey(participant.jid, 'video');
      const remoteVideoTrack = participantsTracks[trackKey];

      if (remoteVideoTrack?.muted === false) {
        requestIds.push(remoteVideoTrack?.jitsiTrack?.getSourceName());
        participant.track = remoteVideoTrack.jitsiTrack;
      } else {
        participant.track = null;
      }
    }

    return participant;
  });
  if (!audioMode) {
    changeTrackResolutionAudienceMode(requestIds,recentSpeakersCount);
  }

  console.log('setAudienceTracks 2', _participants);

  dispatch(setAudienceParticipants(_participants));
};

export const randomString = length => {
  var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var result = '';
  for (var i = length; i > 0; --i) {
    result += chars[Math.floor(Math.random() * chars.length)];
  }
  return result;
};

export const getParticipantBlockStatus = participant => {
  const state = store.getState();
  const { participantsJID } = state.conf;
  let currentStatus = participantsJID[participant?.jid]?.blocked;
  return currentStatus;
};

export const logSentryCustomEvent = (message, level = 'info', data = {}) => {
  const state = store.getState();
  const { roomDetail } = state.conf;
  const { logger } = Sentry;
  const logMessage = `${roomDetail?.room} - Recorder - ${message}`;
  const project = isRlink ? 'rlink' : 'meetn';

  try {
    const meta = {
      extra: {
        ...data,
        project,
      },
    };
    logger.info(logMessage, meta);
  } catch (err) {
    console.error('Sentry logging failed:', err);
  }
};

export function getIP(value) {
  if (!value) {
    return '';
  }

  return value.substring(0, value.lastIndexOf(':'));
}

export const handleActiveTimer = (doc, event_type) => {
  const state = store.getState();
  const { roomDetail, localUser } = state.conf;

  const { dispatch } = store;

  if (doc.extensionid === getWidgetCode('hide-popup')) {
    dispatch(setTimerExtensionShow(false));
    dispatch(setTimerExtensionDetails({}));

    dispatch(setActiveTimerWidget({}));
    dispatch(setLastActiveWidget(doc));
  } else {
    dispatch(setTimerExtensionShow(true));
    dispatch(setTimerExtensionDetails(doc));
    dispatch(setActiveTimerWidget(doc));
    dispatch(setLastActiveWidget(doc));
  }
};
